import ChargeTable from './ChargeTable';
import DashboardTableHeader from './DashboardTableHeader';

export default function DashboardTableCharges() {
    return (
        <>
            <DashboardTableHeader />
            <ChargeTable />
        </>
    )
}